import { I18n } from 'react-redux-i18n';
import { externalIntegrationSystemOptions } from '../pages/event/constants';

export const externalIntegrationSystemLabel = (value?: string | null) => {
  const option = externalIntegrationSystemOptions.find(
    (item) => item.value === value
  );
  return option?.text ? I18n.t(option.text) : '';
};

// Every defined system, without the blank "none" entry, labelled for a dropdown.
export const registrationPlatformOptions = () =>
  externalIntegrationSystemOptions
    .filter((item) => item.value)
    .map((item) => ({ value: item.value as string, text: I18n.t(item.text) }));
